import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const contractUri = config.apiEndpoints.contractUri
const contractExportUri = config.apiEndpoints.contractExportUri
export default {
    findAll: (searchOptions, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "page": page,
                "pageSize": pageSize,
                "keywords": searchOptions.keywords,
                "status": searchOptions.status
            }
            HTTP.get(contractUri.concat('search'), { params: model }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (keywords) => {
        return new Promise((resolve, reject) => {
            HTTP.get(contractUri, { params: { keywords } }).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findDetailed: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(contractUri.concat(`${id}/details`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(contractUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(contractUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(contractUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getContractUri: (sellerId) => {
        return `${contractExportUri}${sellerId}`
    }
}